import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';

export default function* () {
    yield takeLatest(constants.CHANGE_LANGUAGE.REQUEST, saga.changeLanguageRequest);
    yield takeLatest(constants.CHANGE_LANGUAGE.SUCCESS, saga.changeLanguageSuccess);
}
